import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import React from 'react';
import { Control, LocalForm, Errors } from 'react-redux-form';
import PropTypes, { number } from 'prop-types';
import Alert from '../../container/Alert';
import Comfirm from '../../container/Comfirm';
import Header from '../Header';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import{Checkbox } from '@material-ui/core';
// import Spinner from '../Snowflake/as/Spinner';

const messages = defineMessages({
  htmlHeader: {
    id: 'confirmation.html.header1',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Translated Code Release Request'
  },
  headerTitle: {
    id: 'translationapproval.header.title1',
    description: 'Page Header Title',
    defaultMessage: 'Request Translated Code Release'
  },
  headerSubTitle: {
    id: 'translationapproval.header.subtitle1',
    description: 'Page Header Subtitle',
    defaultMessage: 'Request Translated Code Release'
  }
});

const print = status => {
  if (status.payload) {
    // console.log(status.payload.response);
    return status.payload.response;
  }
};

const TranslatedCodeRequest = props => {
  const { intl } = props;

  return (
    <div className="preview page">
      <Helmet>
        <title>{intl.formatMessage(messages.htmlHeader)} - SHIFT</title>
      </Helmet>
      <Header
        title={intl.formatMessage(messages.headerTitle)}
        subtitle={intl.formatMessage(messages.headerSubTitle)}
        icon="preview"
        //locale={this.props.locale}
      />
      {/*{this.state.show ? (*/}
          {/*<div   style={{display:"block"}}>*/}
            {/*<Spinner />*/}

          {/*</div>):null}*/}

      <Alert
        title={intl.formatMessage(messages.headerTitle)}
        message={print(props.status)}
      />

      <Comfirm
        pagetitle={intl.formatMessage(messages.headerTitle)}
        message={print(props.status)}
        nextpage="placeOrderMsg"
      />
      <div className="main">
        <div
          className="panel"
          style={{
            width: '60%',
            padding: '40px',
            boxSizing: 'content-box',
            marginTop: '15px',
            display: 'block',
            alignContent: 'center',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <LocalForm
            className="form"
            onSubmit={({ reponame, reference_id, quotation_id,isOrderConfirmed}) => {
              props.transSubmitHandler(reponame, reference_id, quotation_id,isOrderConfirmed);
            }}
          >
            <div
              style={{
                marginLeft: '3%'
              }}
            >
              <fieldset>
                <label style={{ textTransform: 'capitalize' }}>
                  <FormattedMessage
                    id="source.code.repository.name"
                    defaultMessage="Source Code Repository Name: "
                  />
                </label>
                <Control.text
                  model=".reponame"
                  value={props.reponame}
                  disabled
                />
              </fieldset>

              <fieldset>
                <label style={{ textTransform: 'capitalize' }}>
                  <FormattedMessage
                    id="translationapproval.reference.id"
                    defaultMessage="Reference ID: "
                  />
                </label>
                <Control.text
                  model=".reference_id"
                  value={props.reference_id}
                  disabled
                />
              </fieldset>
              <fieldset>
                <label style={{ textTransform: 'capitalize' }}>
                  <FormattedMessage
                    id="translationapproval.reference.id1"
                    defaultMessage="Quotation ID: "
                  />
                </label>
                <Control.text
                  model=".quotation_id"
                  value={props.quotation_id}
                  disabled
                />
              </fieldset>
              <fieldset>
                <label style={{ textTransform: 'capitalize' }}>
                  Client/Project Name:
                </label>
                <Control.text
                  model=".clientname"
                  value={props.clientname}
                  disabled
                />
              </fieldset>

              <fieldset>
                <label style={{ textTransform: 'capitalize' }}>
                Opportunity Number:
                </label>
                <Control.text
                  model=".opportunity_num"
                  // value={props.financialForceId}
                  value={props.opportunity_num}
                  disabled
                />
              </fieldset>
              <fieldset>
                <label style={{ textTransform: 'capitalize' }}>
                  Translation Rate:
                </label>
                <Control.text
                  model=".translationRate"
                  value={props.translationRate}
                  disabled
                />
              </fieldset>
              <fieldset>
                <label style={{ textTransform: 'None',marginLeft:'-14px'}}>
                <Checkbox style={{color:'#1e5c71'}}
                  //model=".isOrderConfirmed"
                  value={props.isOrderConfirmed}
                 // getValue={(event) => event.target.value}
                  onChange = {props.handleOrderconfirmed}
                /> I'm satisfied with the Commercial Translation Report. I want the translated code.
                </label>
                {/* <Control.checkbox  */}

              </fieldset>

              <div className="button-container" style={{ textAlign: 'center' }}>
                <button
                  className="button"
                  style={{ marginRight: '40px' }}
                  type="button"
                  onClick={() => props.clickBackHandler()}
                >
                  <FormattedMessage
                    id="run-assessment.back.button.name1"
                    defaultMessage="Cancel"
                  />
                </button>
                <button className="button" type="submit">
                  <FormattedMessage
                    id="submit.button.name1"
                    defaultMessage="Request Translated Code Release"
                  />
                </button>
              </div>
            </div>
          </LocalForm>
        </div>
      </div>
      <Footer />
    </div>
  );
};

TranslatedCodeRequest.propTypes = {
  transSubmitHandler: PropTypes.func.isRequired
};

export default injectIntl(TranslatedCodeRequest);



// WEBPACK FOOTER //
// ./src/components/views/TranslatedCodeRequest/index.js